import { Suspense, useContext, useEffect,useRef } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { Chart } from "primereact/chart";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import moment from "moment";
import {deleteSurveyForm, deleteSurveyFormAllResponse, getFormUserList, getSurveyList, stopSurveyForm ,deleteSurveyIndividualResponse} from "./Services/surveyService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Dropdown } from "primereact/dropdown";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
// import * as <XLSX></XLSX> from "xlsx";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SurvayResult = () => {  
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const { SurveyFormId } = useParams();
  const [surveyList, setSurveyList] = useState([]);
  const [IsLoading, setLoading] = useState();
  const [userList, setUsers] = useState([]);
  const [selectedEmpId, setSelectedEmpId] = useState([]);
  let history = useHistory();
  const toster = useContext(TostMsg);
  const [deleteType, setDeleteType] = useState(null);
    const [deleteFormId, setDeleteFormId] = useState(0);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [create, setCreate] = useState(false);
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    GetSurveyList();
    permissionAccouncementList();
    fetchFormUserList();

  }, [SurveyFormId]);

  useEffect(() => { }, [selectedEmpId])

  const permissionAccouncementList = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Survey.Create") {
        setCreate(true);
      } else if (UserPermission.PermissionName == "Survey.Manage") {
        setUpdate(true);
      }
    });
  };
  async function fetchFormUserList(formId) {
    var params = {
      Id: formId
    };
    try {
      let employeesList = await getFormUserList(params);
      setUsers(employeesList.Data);
      console.log(userList);
    } catch (error) { }
  }

  // history.push(`/Survay/IndividualSurvey/${e.value}/${SurveyFormId}`);
  //               }

  async function GetSurveyList() {
    setLoading(true);
    const params = {
      FormId: 0,
      EmpGUID: "",
      FormGUID: SurveyFormId,
      PageNumber: 1,
      PageSize: 10000,
      EmpId: userDetails.OrgId,
      MyCreatedSurvey: 0,
      MyParticipation: 0,
      Search: "",

    };
    try {
      let data = await getSurveyList(params);
      setSurveyList(data?.Data);
      setDeleteFormId(data?.Data[0]?.FormId)
      fetchFormUserList(data?.Data[0]?.FormId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

   const handleExport = (value) => { 
  if (value === "open") {
    openInExcel();
  }

  if (value === "download") {
    downloadExcel();
  }
};

// const generateExcel = () => {
//   const data = surveyList[0]?.Questions?.map((q) => ({
//     Question: q.Question,
//     TotalResponses: q.TotalResponses,
//   }));

//   const ws = XLSX.utils.json_to_sheet(data);
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Survey Results");

//   return wb;
// };

// const generateExcel = () => {
//   const data = surveyList[0]?.Questions?.map((q) => ({
//     Question: q.QuestionTitle,
//     TotalResponses: q.Options?.reduce(
//       (sum, opt) => sum + (opt.QOTRPercentage || 0),
//       0
//     ),
//   }));

//   const ws = XLSX.utils.json_to_sheet(data);
//   const wb = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(wb, ws, "Survey Results");

//   return wb;
// };

const generateExcel = () => {
  if (!surveyList?.length || !surveyList[0]?.Questions?.length) {
    alert("No data available");
    return;
  }

  let data = [];

  surveyList[0].Questions.forEach((q) => {
    q.Options?.forEach((opt, index) => {
      data.push({
        Question: q.QuestionTitle,
        Option: `${getOptionLetter(index)}. ${opt.OptionText}`,
        Percentage: `${opt.QOTRPercentage || 0}%`,
      });
    });
  });

  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Survey Results");

  return wb;
};

const openInExcel = () => { 
  const workbook = generateExcel();
  XLSX.writeFile(workbook, "SurveyResults.xlsx");
};

const downloadExcel = () => { 
  const workbook = generateExcel();

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, "SurveyResults.xlsx");
};

  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    const documentStyle = getComputedStyle(document.documentElement);
    const data = {
      labels: ["A", "B", "C"],
      datasets: [
        {
          data: [300, 50, 100],
          backgroundColor: [
            documentStyle.getPropertyValue("--blue-500"),
            documentStyle.getPropertyValue("--yellow-500"),
            documentStyle.getPropertyValue("--green-500"),
          ],
          hoverBackgroundColor: [
            documentStyle.getPropertyValue("--blue-400"),
            documentStyle.getPropertyValue("--yellow-400"),
            documentStyle.getPropertyValue("--green-400"),
          ],
        },
      ],
    };
    const options = {
      cutout: "60%",
    };

    setChartData(data);
    setChartOptions(options);
  }, []);

  // const employeeOptionTemplate = (option) => {
  //   return (
  //     <div className="flex align-items-center gap-2 ticket-file-attach__items_detail"  >
  //       <LazyImage
  //         alt={option?.EmployeeName}
  //         src={option?.ProfileImage}
  //         width="32"
  //       />
  //       <span>
  //         {option?.EmployeeName}
  //         {option?.CurrentDesignation?.length > 0 && ","}
  //       </span>
  //       <span>{option?.CurrentDesignation}</span>
  //     </div>
  //   );
  // };

  const employeeOptionTemplate = (option) => {
  const isSelected = selectedEmpId?.EmpGUId === option?.EmpGUId;

  return (
    <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
      <input
        type="radio"
        checked={isSelected}
        readOnly
        style={{ marginRight: "8px" }}
      />

      <LazyImage
        alt={option?.EmployeeName}
        src={option?.ProfileImage}
        width="32"
      />

      <span>
        {option?.EmployeeName}
        {option?.CurrentDesignation?.length > 0 && ","}
      </span>

      <span>{option?.CurrentDesignation}</span>
    </div>
  );
};

  // async function DeleteAllSurveysResponse() {
  //   setLoading(true);
  //   if (formId) {
  //     let body =
  //     {
  //       FormId: formId,
  //       LoggedInUserId: userDetails?.Id,
  //     }
  //     setLoading(true);
  //     try {
  //       let res = await deleteSurveyFormAllResponse(body);
  //       if (res?.StatusCode === 2000) {
  //         GetSurveyList();
  //         history.push("/Survey/List");
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //     }
  //   }
  // }


  // async function DeleteSurveys() {
  //   setLoading(true);
  //   if (formId) {
  //     let body = {
  //       Id: formId,
  //     };
  //     setLoading(true);
  //     try {
  //       let res = await deleteSurveyForm(body);
  //       if (res?.StatusCode === 2000) {
  //         GetSurveyList();
  //         history.push("/Survey/List");
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //     }
  //   }
  // }

  const getOptionLetter = (index) => {
    return String.fromCharCode(65 + index);
  };


  const renderOptionsByType = (el) => {
    const type = Number(el.QuestionType);

    switch (type) {
      case 101: // Checkbox
        return el?.Options?.map((opt, i) => (
          <div className="form-check" key={i}>
            <input className="form-check-input" type="checkbox" disabled />
            <label className="form-check-label">{opt.OptionText}</label>
          </div>
        ));

      case 102: // Radio
        return el?.Options?.map((opt, i) => (
          <div className="form-check" key={i}>
            <input
              className="form-check-input"
              type="radio"
              name={`q-${el.QuestionId}`}
              disabled
            />
            <label className="form-check-label">{opt.OptionText}</label>
          </div>
        ));

      case 103: // Dropdown
        return (
          <select className="form-select">
            {el?.Options?.map((opt, i) => (
              <option key={i}>{opt.OptionText}</option>
            ))}
          </select>
        );

      case 104: // Text Input
        return (
          <input
            type="text"
            className="form-control"
            placeholder="User response"
            disabled
          />
        );

      default:
        return null;
    }
  };

  // async function StopSurveyForm() { 
  //   setLoading(true);
  //   let body = {
  //     FormId: SurveyFormId,
  //     LoggedInUserId: userDetails?.EmpId,
  //   };
  //   try {
  //     let res = await stopSurveyForm(body);
  //     if (res?.StatusCode === 2000) {
  //       GetSurveyList();
  //       // setPage(1);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     toster.current.error(ERROR_LIST.DefaultError);
  //   }
  // }


    async function StopSurveyForm(FormId) {
      setLoading(true);
      let body = {
        FormId: FormId,
        LoggedInUserId: userDetails?.EmpId,
      };
      try {
        let res = await stopSurveyForm(body);
        if (res?.StatusCode === 2000) {
          GetSurveyList();
          // setPage(1);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }

  async function DeleteIndividualResponse() { 
    setLoading(true);
    if (deleteFormId) {
      let body = {
        FormId: deleteFormId,
        EmpId: selectedEmpId?.EmpId
      };
      setLoading(true);
      try {
        let res = await deleteSurveyIndividualResponse(body);
        if (res?.StatusCode === 2000) {
          toster.current.success("Survey Deleted Successfully");
          history.push("/Survey/List");
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

  async function DeleteSurveyFormAllResponse() {
    setLoading(true);
    if (deleteFormId) {
      let body = {
        FormId: Number(deleteFormId),
        LoggedInUserId: userDetails?.EmpId,
        // EmpId: userDetails?.EmpId,
      };
      setLoading(true);
      try {
        let res = await deleteSurveyFormAllResponse(body);
        if (res?.StatusCode === 2000) {
          toster.current.success("All responses Deleted Successfully");
          history.push("/Survey/List")
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        toster.current.error(ERROR_LIST.DefaultError);
      }
    }
  }

    const scrolltoSubmit = useRef(null);
    const handleClick = () => { 
      scrolltoSubmit?.current?.scrollIntoView({ behavior: "smooth" });
    };

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      {/* <!-- row --> */}
      <div className="container-fluid">
        <div className="row g-3 assessment-module">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center mb-2">
              <div className="me-auto">
                <h2 className="font-w600 mb-0"></h2>
              </div>
              <div className="rightside-tabs">

               {(create || update) &&  <button className="btn btn-danger me-2" onClick={() => StopSurveyForm(surveyList[0]?.FormId)}>Stop</button>}
               {(create || update) &&  
              //  <a className="btn btn-danger me-2" style={{ cursor: "pointer" }}
              //     data-toggle="tooltip"
              //     data-placement="top"
              //     data-bs-toggle="modal"
              //     data-bs-target="#delete-ed"
              //     title=""
              //     onClick={handleClick}
              //     data-bs-original-title="delete"
              //     aria-label="delete">
              //     Delete
              //   </a>
//               <a
//   className="btn btn-danger me-2"
//   style={{ cursor: "pointer" }}
//   data-toggle="tooltip"
//   data-placement="top"
//   title=""
//   onClick={handleClick}
//   data-bs-original-title="delete"
//   aria-label="delete"
// >
//   Delete
// </a>   

              <a
  className="btn btn-danger me-2"
  style={{ cursor: "pointer" }}
  data-bs-toggle="modal"
  // data-bs-target="#delete-ed"
  onClick={() => {
    // setDeleteType(0);
    handleClick();
  }}
>
  Delete
</a>
                }
                {(create || update) && <a className="btn btn-danger me-2"
                  style={{ cursor: "pointer" }}
                  data-toggle="tooltip"
                  data-placement="top"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-ed"
                  title=""
                  data-bs-original-title="delete"
                  onClick={() => setDeleteType(1)}
                  aria-label="delete">

                  Delete All Responses
                </a>}
                {/* {(create || update) && <Link to={`/Survey/Update/${SurveyFormId}`}
                  className="btn btn-purple ">Edit</Link>} */}
                <Link to="/Survey/List">
                  <button
                    className="add-newticket w-auto "
                    style={{ minWidth: "fit-content" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="page-content-inner all-projects mt-0">
              <div className="assessment-block survay-result-block">
                <div className="illustration-header00">
                  <div className="header-meta">
                    <div className="first-divblock">
                      <div>
                        <h3>{surveyList[0]?.Title}</h3>
                        <p className="font-w600 mb-0">{surveyList[0]?.Description}</p>
                        <ul className="basicinfomation">
                          <li>
                            <i className="fa fa-user-o" aria-hidden="true"></i>
                            Responses : <b className="emp-count">{surveyList[0]?.TotalResponses || 'N/A'}</b>
                          </li>
                        </ul>
                      </div>
                      <div className="ml-auto d-flex align-items-start">
                        <span className="assessment-status-initiated me-2">
                          {surveyList[0]?.FormStatus}
                        </span>
                      </div>
                    </div>
                    <div className="summary-stats">
                      <div className="summary-stat">
                        <img src="/images/pms/start-date.svg" />
                        <div>
                          <span>Initiated On</span>
                          <span>
                            {moment(surveyList[0]?.InitiatedOn).format(
                              "MMM DD YYYY",
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="summary-stat">
                        <img src="/images/pms/start-date.svg" />
                        <div>
                          <span>Total Participation</span>
                          <span>{surveyList[0]?.TotalParticipation != 0 ? surveyList[0]?.TotalParticipation : '0'}</span>
                        </div>
                      </div>

                      <div className="summary-stat">
                        <img src="/images/pms/start-date.svg" />
                        <div>
                          <span>Pending Responses</span>
                          <span>{surveyList[0]?.PendingPercentage != 0 ? surveyList[0]?.PendingPercentage + '%' : '0'}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-8">
            {/* <div className="assessment-block"> */}
            <div className="assessment-block">
              {surveyList[0]?.Questions?.map((item, index) => {
                const selectedOption = item.Options.find(
                  (opt) => opt.EmpSelectedOptionId === opt.OptionId
                );

                return (
                  <div className="illustration-header00" key={item.QuestionId}>
                    <div className="header-meta">
                      <div className="first-divblock">
                        <h3>
                          {index + 1}. {item.QuestionTitle}
                        </h3>
                      </div>

                      <div className="question-options">
                        <div className="row align-items-center">
                          <div className="col-lg-8">
  <ul>
    {item.Options.map((opt, optIndex) => {
      return (
        <li key={opt.OptionId}>
          <span
            className="pert-color"
            style={{ color: opt.QOTRPercentageColor }}
          >
            {getOptionLetter(optIndex)}.
          </span>{" "}
          {opt.OptionText}
          <span className="quest-percentage">
            ({opt?.QOTRPercentage}%)
          </span>
        </li>
      );
    })}
  </ul>

  {/* User response */}
  {selectedOption && (
    <h6>
      Your response was{" "}
      <strong>{selectedOption.EmpResponseText}</strong>{" "}
      <span className="text-purple">
        (
        {getOptionLetter(
          item.Options.findIndex(
            (o) => o.OptionId === selectedOption.OptionId
          )
        )}
        )
      </span>
    </h6>
  )}
</div>

                          <div className="col-lg-4">
                            {selectedOption && (
                              <Chart
                                type="doughnut"
                                data={{
                                  labels: item.Options.map((opt, idx) => getOptionLetter(idx)),
                                  datasets: [
                                    {
                                      data: item.Options.map((opt) => opt.QOTRPercentage),
                                      backgroundColor: [
                                        "#4CAF50",
                                        "#2196F3",
                                        "#FF9800",
                                        "#9C27B0",
                                        "#F44336",
                                      ],
                                    },
                                  ],
                                }}
                                options={chartOptions}
                                className="w-full md:w-20rem"
                              />
                              // <Chart
                              //   type="doughnut"
                              //   data={{
                              //     labels: ["Completed", "Remaining"],
                              //     datasets: [
                              //       {
                              //         data: [
                              //           selectedOption.QOTRPercentage,
                              //           100 - selectedOption.QOTRPercentage,
                              //         ],
                              //       },
                              //     ],
                              //   }}
                              //   options={chartOptions}
                              //   className="w-full md:w-20rem"
                              // />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-xl-4">
            <div className="card">
              <div className="card-body">
                <div className="card-title d-flex justify-content-between">
                  <h4>Insights and actions</h4>
                </div>
                <p className="note-p">
                  Use Excel to view up-to-date results in table and sort,
                  filter, pivot, or chart your data.
                </p>

                {/* <select class="form-select" aria-label="Default select example">
                  <option selected>
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-file-excel "
                        viewBox="0 0 16 16"
                      >
                        <path d="M5.18 4.616a.5.5 0 0 1 .704.064L8 7.219l2.116-2.54a.5.5 0 1 1 .768.641L8.651 8l2.233 2.68a.5.5 0 0 1-.768.64L8 8.781l-2.116 2.54a.5.5 0 0 1-.768-.641L7.349 8 5.116 5.32a.5.5 0 0 1 .064-.704" />
                        <path d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1" />
                      </svg>
                    </span>{" "}
                    Open result in Excel{" "}
                  </option>
                  <option value="1">
                    <span className="me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-arrow-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                        />
                      </svg>
                    </span>
                    Download a Copy
                  </option>
                </select> */}

                <select
                 className="form-select"
               aria-label="Default select example"
               onChange={(e) => handleExport(e.target.value)}
               defaultValue=""
               >
              <option value="" disabled>
               Open result in Excel
              </option>

       <option value="open">
         Open result in Excel
       </option>

  <option value="download">
    Download a Copy
  </option>
</select>


                
              </div>
            </div>

            {(create || update) && (<div className="card">
              <div className="card-body">
                <div className="card-title d-flex justify-content-between">
                  <h4>view individual responses</h4>
                </div>

                {/* <Dropdown
                  value={selectedEmpId}
                  ref={scrolltoSubmit}
                  options={userList}
                  optionLabel="EmployeeName"
                  placeholder="Choose"
                  filter
                  name="EmpId"
                  onChange={(e) => setSelectedEmpId(e.value)}
                  itemTemplate={employeeOptionTemplate}
                  className="w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect leaveforteam"
                /> */}
                <div ref={scrolltoSubmit}>
                <Dropdown
                 value={selectedEmpId}
                 options={userList}
                 optionLabel="EmployeeName"
                 placeholder="Choose"
                 filter
                 name="EmpId"
                 onChange={(e) => setSelectedEmpId(e.value)}
                 itemTemplate={employeeOptionTemplate}
                className="w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect leaveforteam"
               />
              </div>
                <div class="content-indivisual-box mb-3">
                  {/* <p>
                    <b>Start date:</b> {moment(surveyList[0]?.InitiatedOn).format(
                              "MMM DD YYYY",
                            )}
                  </p> */}

                  <h6>
                    Responses :{surveyList[0]?.TotalResponses || 'N/A'}
                    {/* <span className="badge badge-warning ">
                      End
                    </span> */}
                  </h6>
                </div>
                {selectedEmpId?.EmpId && <Link
                  to={`/Survey/IndividualSurvey/${surveyList[0]?.FormGUID}/${selectedEmpId?.EmpGUId}`}
                  className="btn btn-link "
                >
                  View Response
                </Link>}
                {selectedEmpId?.EmpId && (
  <button
   style={{ color: "red" }}
    className="btn btn-link"
    data-bs-toggle="modal"
    data-bs-target="#delete-ed"
    onClick={() => setDeleteType(0)}
  >
    Delete Response
  </button>
)}
              </div>
            </div>)}
          </div>

        </div>
      </div>
      <div className="modal fade" id="delete-ed">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content delete-holiday">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <div className="img">
                <img src="/images/org-img/leave/trash.png" />
              </div>
            </div>
            <div className="modal-body text-center">
              <strong className="modal-title">Are you sure?</strong>
              <p>Do you really want to delete {deleteType ? "all responses" : "this response"}?</p>
            </div>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              {deleteType ? <button
                type="button"
                className="savebtn-click"
                data-bs-dismiss="modal"
                onClick={() => DeleteSurveyFormAllResponse()}
              >
                Delete
              </button> : <button
                type="button"
                className="savebtn-click"
                data-bs-dismiss="modal"
                onClick={() => DeleteIndividualResponse()}
              >
                Delete
              </button>}
            </div>
          </div>
        </div>
      </div>
      {IsLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};
export default SurvayResult;
